class SettingsService {
    static get = (key) => {
        if (!window.drupalSettings) {
            return null;
        }

        return window.drupalSettings[key];
    };
}

export default SettingsService;
